import React from 'react'
import PropTypes from 'prop-types'
import { ApolloConsumer } from 'react-apollo'

class AppApolloConsumer extends React.PureComponent {
  render () {
    const { children } = this.props
    return (
      <ApolloConsumer >
        {(client) => children({ client })}
      </ApolloConsumer>
    )
  }
}

AppApolloConsumer.propTypes = {
  children: PropTypes.any
}

export default AppApolloConsumer
